<template>
    <div class='login-body'>
        <!-- <div class='logoImage'>
            <img src='../../public/layout/images/logo.png'>
        </div> -->
        <div class="login-write"></div>
        <Toast position='top-center' />
        <div class='login-panel p-fluid'>
            <div class=' flex-column contentBox' style="display:none;">

                <div style='color:#31558F;position:absolute; width:100%;height:35%;'>
                    <h1 class='ml11'>
                        <span class='text-wrapper'>
                            <span class='line line1'></span>
                            <span class='letters' style='font-weight:700;font-size: 4vw;letter-spacing: 1px;'>Predicine
                                |
                                BioTechLeague</span>
                        </span>
                    </h1>
                    <div style='color:black;font-weight:100;margin-top:50px;font-size:1.25vw'>
                        {{ $t('login.bio_serve') }}
                    </div>
                    <div style='color:black;font-weight:100;font-size:1.25vw'>{{ $t('login.bio_scheme') }}
                    </div>
                    <div class='content1'>{{ $t('login.bio_number') }}</div>
                </div>
                <div class=' align-items-center logo-container justify-content-center'>
                    <div class='content2'>&#169;{{ $t('login.bio_copyright') }}</div>
                </div>
            </div>
            <div class='flex flex-column loginBox' v-if="step == 'login'">
                <div class='version' style='margin-top:20px;font-size: 18px;letter-spacing: 3px;color:#A3A3A3;'>
                    <div class='logoPImage'>
                        <img src='../../public/layout/images/Predicine_DIRECT_Logo.ai.png'>
                    </div>
                </div>
                <div style="margin-top: 50px;">Log in with</div>
                <div class='form-container'>
                    <!--          <span class='p-input-icon-left' style='width:96%;margin-left:2%;margin-top:23px;'>
				                <i class='pi pi-user'></i>
				                <InputText style='height:45px' v-model='username' type='text' :placeholder="$t('login.in_userName')" />
				              </span>
				                        <div class='fp-input-icon-left text-left' v-if='plaseholder'>
				                            <span class='color-red'>{{ plaseholder }}</span>
				                        </div>
				                        <span class='p-input-icon-left' style='width:96%;margin-left:2%;margin-top:23px'>
				                <i class='pi pi-key'></i>
				                <InputText style='height:45px' v-model='password' @keyup.enter='goLogin' type='password'
				                           :placeholder="$t('login.in_password')" @keyup='searchPassword(password)' />5
				              </span>-->
                    <button id='microsoft-auth-button'
                        style="margin-top: 20px; width: 200px;border: none;transform: scale(1.5);" @click='goLogin'
                        aria-busy='false' class='css-8x8i7r css-q2jxx8' tabindex='0' type='button'><span
                            class='css-bwxjrz'><img
                                src='https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.522/microsoft-logo.c73d8dca.svg'
                                alt=''></span><span class='css-178ag6o'>Microsoft</span></button>
                </div>
                <div class=' align-items-center logo-container justify-content-center' style="margin-top: 20px;">
                    <div style='color:#000000;'>
                        <h3 style='font-weight:500;letter-spacing: 1px;' class='bioTitle'> V1.0</h3>
                    </div>
                </div>
                <!-- <div style='height:3px;width:50%;margin-left:25%; background:lightskyblue;border-radius: 10px;'></div> -->


                <!--                <div class='button-container'>-->
                <!--                    <router-link to='/'>-->
                <!--                        <Button style='width:96%; height:40px;margin-left:2%;margin-top:15px;' type='button'-->
                <!--                                :label="$t('login.login')" @click='goLogin'></Button>-->
                <!--                    </router-link>-->
                <!--                </diva>-->
            </div>
        </div>
        <div class="footer">
            <!--			<a href="https://www.biolims.net/" target="_blank">Powered by Bio-LIMS Software Technology Co., Ltd</a>-->
        </div>
        <div>
            <!--            <div class='content2'>&#169;{{ $t('login.bio_copyright') }}</div>-->
            <Sidebar :showCloseIcon="false" style="padding-top:8px;height:6rem;border-radius:0" v-model:visible="visible"
                :position="'top'" :modal="false" header="">
                <div class="" style="display: flex;justify-content: center; align-items: center;gap:2rem">
                    <p style="margin:0;font-size: 16px;">We use cookies to give you a better experience on
                        predicine.com. By continuing to use our website, you are agreeing to the use of cookies as set
                        out in our <a href="https://www.predicine.com/privacy-policy/" target="_blank" style="text-decoration: underline;"
                            >Privacy Pollcy</a></p>
                            <!-- target="_blank" -->
                    <Button @click="accept">Accept</Button>
                </div>
            </Sidebar>
        </div>
    </div>
</template>

<script>
import requests from '../request';

import Sidebar from 'primevue/sidebar';

export default {
    components: {
        Sidebar
    },
    data() {
        return {
            step: 'login',
            selectedLanguage: 'zh_CN',
            visible: false,
            accepted: false,
        };
    },
    computed: {},
    methods: {
        accept() {
            requests({
                url: '/user/acceptCookies',
                method: 'POST',
                params: {
                },
            }).then((res) => {
                if (res.data.status == 200) {
                    this.visible = false
                    this.accepted = true
                }
            })
        },
        verify() {
            requests({
                url: '/user/checkedCookies',
                method: 'POST',
                params: {
                },
            }).then((res) => {
                if (res.data.status == 200) {
                    if (res.data.data) {//
                        this.visible = false;//显示
                        this.accepted = true;
                    }else{
                        this.accepted = false;
                        this.visible = true;//显示
                    }
                }
            })
        },
        goLogin() {
            if(!this.accepted){
                this.$toast.add({
                    severity: 'warn',
                    summary:   'Please accept cookies',
                    life: 2000
                });
                return;
            }
            var state = this.generateUUID();
            var nonce = this.generateUUID();
            console.log("Login.............")
            /*pd.  pd-demo*/
            window.location.href = 'https://login.microsoftonline.com/2a30e130-2b50-4dd8-a834-1bd5410cccb7/oauth2/v2.0/authorize' +
                '?scope=openid+profile+offline_access+&response_type=code&redirect_uri=https://pd-demo.predicine.com/login&state=' + state + '&nonce=' + nonce + '&prompt=select_account' +
                '&client_id=5fc0943e-177e-4019-8c0c-a4eece97bb98';

            // VUE_APP_CLIENT_ID=5fc0943e-177e-4019-8c0c-a4eece97bb98
            // VUE_APP_REDIRECT_URI=https://pd-demo.predicine.com/login
            // VUE_APP_REPORT_URI=https://p3-demo.predicine.com/index

            // --美国
            //测试5fc0943e-177e-4019-8c0c-a4eece97bb98 生产d77b9930-bca4-4936-bd80-134f375c3705
            //--上海   https://pd-demo.huidumed.com
            //测试 d6d4ed36-14fe-4683-a1d9-ecc3bb222171
        },
        generateUUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }
    },
    mounted() {
        this.verify()
    },
    created() {
        const queryString = window.location.search;
        const params = queryString.split('?')[1];
        if (params != null && params != undefined && params != "") {
            const paramArray = params.split('&');
            const parameters = {};
            paramArray.forEach(param => {
                const [key, value] = param.split('=');
                parameters[key] = value;
            });
            if (parameters.code != "" && parameters.code != null && parameters.code != undefined) {
                requests({
                    url: '/user/Login',
                    method: 'POST',
                    params: {
                        code: parameters.code,
                    },
                }).then((res) => {
                    if (res.data.status === 200) {
                        localStorage.setItem('userName', res.data.data.username);
                        localStorage.setItem('firstName', res.data.data.firstName);
                        localStorage.setItem('lastName', res.data.data.lastName);
                        localStorage.setItem('title', res.data.data.title);
                        localStorage.setItem('clientName', res.data.data.clientName);
                        localStorage.setItem('micAccountName', res.data.data.micAccountName);
                        localStorage.setItem('sessionId', res.data.data.sessionId);
                        localStorage.setItem('isShowSample', res.data.data.isShowSample);
                        localStorage.setItem('isShowProject', res.data.data.isShowProject);

                        this.$message({
                            message: this.$t('login.success'),
                            type: 'success',
                        });
                        if (parameters.searchMessage != "" && parameters.searchMessage != null && parameters.searchMessage != undefined) {
                            localStorage.setItem('searchMessage', parameters.searchMessage);
                            //延时跳转
                            setTimeout(() => {
                                // this.$router.push('/dashboard');
                                this.$router.push('/SampleStatus');
                            }, 1000);
                        } else {
                            //延时跳转
                            setTimeout(() => {
                                // this.$router.push('/dashboard');
                                this.$router.push('/project');
                            }, 1000);
                        }
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'error',
                        });
                        this.$router.push('/');
                    }
                });
            } else {
                localStorage.setItem('language', 'zh_CN');
                this.$i18n.locale = localStorage.getItem('language');
                if (localStorage.getItem('token')) {
                    localStorage.removeItem('token');
                }
                if (localStorage.getItem('userName')) {
                    localStorage.removeItem('userName');
                }
                if (localStorage.getItem('X-DS')) {
                    localStorage.removeItem('X-DS');
                }
                if (localStorage.getItem('router')) {
                    localStorage.removeItem('router');
                }
            }
        } else {
            localStorage.setItem('language', 'zh_CN');
            this.$i18n.locale = localStorage.getItem('language');
            if (localStorage.getItem('token')) {
                localStorage.removeItem('token');
            }
            if (localStorage.getItem('userName')) {
                localStorage.removeItem('userName');
            }
            if (localStorage.getItem('X-DS')) {
                localStorage.removeItem('X-DS');
            }
            if (localStorage.getItem('router')) {
                localStorage.removeItem('router');
            }
        }
    },
    watch: {
        step(val) {
            this.plaseholder = null;
        },
    },
};
</script>
<style lang='scss' scoped>
.color-red {
    color: #f102167a;
}

.text-left {
    text-align: left;
    padding: 0 5px;
    line-height: 20px;
    margin: 0 0 10px;
    border-radius: 3px;
    background: rgba(245, 239, 239, 0.685);
}

.login-body {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: url(../../public/layout/images/homePage6.jpg);
    // background-size: 100% 100%;
    background-size: cover;
    background-position: 100% 0%;

    .login-write {
        position: absolute;
        right: 0;
        background: #ffffff;
        top: 0;
        height: 100%;
        width: 35%;
    }

    .login-panel {
        padding: 0;

        .contentBox {
            width: 56%;
            height: 70%;
            //background:lightgray;
            position: fixed;
            left: 4%;
            right: 0;
            top: 30%;
            bottom: 0;

            .content1 {
                font-weight: 100;
                font-size: 1.1vw;
                width: 25%;
                background: lightgray;
                margin: auto;
                left: 0;
                right: 0;
                position: absolute;

                //top:40%;
                border-radius: 20px;
                background-color: rgb(49, 85, 143);
                color: white;
                padding: 12px;
            }

            .content2 {
                width: 54%;
                font-weight: 100;
                font-size: 0.9vw;
                letter-spacing: 1px;
                border-radius: 100px;
                border: 1px solid gray;
                padding: 10px;
                //margin-top:270px;
                position: absolute;
                top: 85%;
                margin-left: 23%;
            }
        }

        .loginBox {
            padding: 20px;
            width: 500px;
            height: 350px;
            //width: 27vw;
            //height: 34vw;
            /* background: #fff; */
            position: fixed;
            left: 37%;
            right: 0;
            top: 25%;
            bottom: 0;
            //margin: auto;
            border-radius: 10px;

            transform:translate(-50%, -50%) .form-container {
                .p-input-icon-left>i:first-of-type {
                    color: #868c9b;
                }

                input {
                    // max-width: 400px;
                    width: 100%;
                    max-width: 1000px;
                    background: #eee;
                    color: #333;
                }
            }

            .button-container button {
                max-width: 400px;
            }
        }

        .login-footer {
            left: 0;
            right: 0;
        }
    }
}

.languageWarp {
    margin-top: 15px
}

.bioTitle {
    font-size: 15px;
}

.footer {
    position: fixed;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    color: black;

    a {
        /*去除默认的颜色和点击后变化的颜色 */
        text-decoration: none;
        /*去除默认的下划线*/
        color: #000;
    }
}

.contentFooter {
    display: none;
}

@mixin footerStyle {
    position: fixed;
    bottom: 0;
    width: 80vw;
    font-weight: 100;
    font-size: 0.5vw;
    letter-spacing: 5px;
    border-radius: 20px;
    border: 1px solid gray;
    padding: 2px;
    position: absolute;
    top: 90%;
    display: flex;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
    color: gray;
    font-size: 1.6vh;
}

// @media screen and (max-width: 768px) {
@media screen and (max-width: 1000px) {
    .login-body .login-panel .contentBox {
        display: none;
    }

    .login-body .login-panel .loginBox {
        position: static;
        width: 80%;
        min-width: 370px;
        height: auto;
    }

    .login-body .login-panel .button-container button {
        max-width: 1000px !important;
    }

    .languageWarp {
        margin-top: 0
    }

    .bioTitle {
        font-size: 20px;
        white-space: nowrap;
    }

    .contentFooter {
        display: block;
        @include footerStyle;
    }

    .logoImage {
        img {
            height: 30px;
            //position: ;
            right: 13px;
            top: 22px;
        }
    }
}

@media screen and (max-width: 576px) {
    .login-body .login-panel .contentBox {
        display: none;
    }

    .login-body .login-panel .loginBox {
        position: static;
        width: 80%;
        min-width: 370px;
        height: auto;
        // transform: scale(0.86);
    }

    .languageWarp {
        margin-top: 0
    }

    .bioTitle {
        font-size: 20px;
        white-space: nowrap;
    }

    .contentFooter {
        display: block;
        @include footerStyle;
    }

    .version {
        margin-top: 0 !important;
    }

    .resetTitle {
        white-space: nowrap;
        font-size: 20px !important;
    }

    .logoImage {
        img {
            height: 46px;
            //position: absolute;
            right: 13px;
            top: 22px;
            min-height: 45px;
        }
    }
}
</style>
<style lang='scss'>
.ml11 {
    font-weight: 700;
    font-size: 3.5em;
}

.ml11 .text-wrapper {
    position: relative;
    display: inline-block;
    padding-top: 0.1em;
    padding-right: 0.05em;
    padding-bottom: 0.15em;
}

.ml11 .line {
    opacity: 0;
    position: absolute;
    left: 0;
    height: 100%;
    width: 3px;
    background-color: #fff;
    transform-origin: 0 50%;
}

.ml11 .line1 {
    top: 0;
    left: 0;
}

.ml11 .letter {
    display: inline-block;
    line-height: 1em;
}

.toastError {
    .p-toast-message-content {
        background: #fde8e7;
        color: #f5716f;
    }

    .p-toast-message-icon {
        font-size: 2rem !important;
        color: #f5716f !important;
    }

    .p-toast-icon-close-icon {
        color: #f5716f !important;
    }
}

.toastInfo {
    .p-toast-message-content {
        background: #eaebff;
        color: #777ef0;
    }

    .p-toast-message-icon {
        font-size: 2rem !important;
        color: #777ef0 !important;
    }

    .p-toast-icon-close-icon {
        color: #777ef0 !important;
    }
}

.toastSuccess {
    .p-toast-message-content {
        background: #e8f9f3;
        color: #41ad89;
    }

    .p-toast-message-icon {
        font-size: 2rem !important;
        color: #41ad89 !important;
    }

    .p-toast-icon-close-icon {
        color: #41ad89 !important;
    }
}

.toastWarn {
    .p-toast-message-content {
        background: #faf3eb;
        color: #d28c36;
    }

    .p-toast-message-icon {
        font-size: 2rem !important;
        color: #d28c36 !important;
    }

    .p-toast-icon-close-icon {
        color: #d28c36 !important;
    }
}

:deep(.p-toast-message-icon) {
    font-size: 2rem;
}

.custom_password_panel_class {
    background-color: white;
}

.resetPassWordInput {
    &>div {
        display: flex !important;

        i {
            top: -50%
        }
    }
}

.logoImage {
    img {
        width: 16vw;
        height: 3vw;
        position: absolute;
        right: 13px;
        top: 22px;
    }
}

.logoPImage {
    margin-top: 15px;

    img {
        width: 21vw;
        height: 5.2vw;
        right: 13px;
        top: 22px;
    }
}

.css-8x8i7r {
    margin-top: 50px;
    box-shadow: none;
    font-weight: bold;
    border: 1px solid rgb(193, 199, 208);
    border-radius: 3px;
    height: 40px !important;
    line-height: 40px !important;
    background: rgb(255, 255, 255) !important;
}

.css-q2jxx8 {
    -webkit-box-align: baseline;
    align-items: baseline;
    box-sizing: border-box;
    display: inline-flex;
    font-size: inherit;
    font-style: normal;
    font-family: inherit;
    max-width: 100%;
    position: relative;
    text-align: center;
    text-decoration: none;
    transition: background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
    white-space: nowrap;
    cursor: pointer;
    padding: 0px 10px;
    vertical-align: middle;
    width: 100%;
    -webkit-box-pack: center;
    justify-content: center;
    color: var(--ds-text, #42526E) !important;
}

.css-bwxjrz {
    opacity: 1;
    transition: opacity 0.3s ease 0s;
    margin: 0px 2px;
    flex-shrink: 0;
    align-self: center;
    font-size: 0px;
    line-height: 0;
    user-select: none;
}

.css-178ag6o {
    opacity: 1;
    transition: opacity 0.3s ease 0s;
    margin: 0px 2px;
    flex-shrink: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
